export default "/images/loans_add_image.png?075014ca7d1cb77b381eebbc3df55192";